/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import PropTypes from 'prop-types'
import React from 'react'
import {useIntl} from 'react-intl'

import {
    InputGroup,
    InputRightElement,
    Stack
} from '@salesforce/retail-react-app/app/components/shared/ui'

import Field from '../../components/field'
import useLoginFields from '../../components/forms/useLoginFields'
import {colors} from '../../constants'
import Link from '../link'

const LoginFields = ({form, prefix = '', clickForgotPassword}) => {
    const {formatMessage} = useIntl()
    const fields = useLoginFields({form, prefix})

    return (
        <Stack spacing="20px">
            <Field {...fields.email} />
            <InputGroup position="relative">
                <InputRightElement
                    display="flex"
                    width="fit-content"
                    marginRight="20px"
                    top="4px"
                >
                    <Link
                        buttonStyles={{
                            color: colors.primaryGray,
                            fontSize: '14px',
                            height: '15px',
                            fontWeight: '300',
                            textDecoration: 'underline',
                            _hover: {
                                textDecoration: 'underline'
                            },
                            _focus: {
                                background: 'none',
                                backgroundColor: 'none'
                            }
                        }}
                        type={'tertiary'}
                        text={formatMessage({
                            defaultMessage: 'Forgot your password',
                            id: 'login_form.forgot_password'
                        })}
                        onLinkClick={clickForgotPassword}
                    />
                </InputRightElement>
                <Field {...fields.password} passwordHideIcon={false} />
            </InputGroup>
        </Stack>
    )
}

LoginFields.propTypes = {
    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,
    /** Optional prefix for field names */
    prefix: PropTypes.string,
    clickForgotPassword: PropTypes.func
}

export default LoginFields
